// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"b6b2ffd5","276":"a92ccdef","288":"3048d424","874":"2fad4120","984":"9f8d9f35"}[chunkId] + ".chunk.css";
};